import { MMKV } from 'react-native-mmkv';
import { DEFAULT_LANG } from './languages';
import { Telemetry } from 'app/services/telemetry/Telemetry';

let storage: MMKV | null = null;
const KEY = 'app.lang';

const getStorage = () => {
    if (!storage) {
        try {
            storage = new MMKV();
        } catch (error) {
            Telemetry.log('warning', '[i18n] MMKV not available, using fallback:', { error: error as Error });
            return null;
        }
    }
    return storage;
};

export const readStoredLang = () => {
    const storageInstance = getStorage();
    return storageInstance?.getString(KEY) ?? null;
};

export const writeStoredLang = (code: string) => {
    const storageInstance = getStorage();
    if (storageInstance) {
        storageInstance.set(KEY, code);
    }
};

export const languageDetector = {
    type: 'languageDetector' as const,
    async: true,
    init: () => { },
    detect: (callback: (language: string) => void) => {
        const persisted = readStoredLang();
        callback(persisted ?? DEFAULT_LANG);
    },
    cacheUserLanguage: (lang: string) => writeStoredLang(lang),
};
